var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center justify-space-between app-bar"},[_c('router-link',{staticStyle:{"height":"32px"},attrs:{"to":"/"}},[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/logo.jpeg")}})]),_c('div',[_vm._v("Kebinou's dev blog")]),_c('v-btn',{attrs:{"to":"/projects","plain":""}},[_vm._v("Projects")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }